<template>
  <div>
    <div class="share-container mt-3">
      <div class="flex-grow-1">
        Shared by <b>{{ share.fromUser }}</b><br/>
        {{ formattedDate }}
      </div>
      <div class="text-end ps-1 pe-1">
        <a :href="acceptUrl" class="btn btn-light">Save to Mixbrite</a>
      </div>
    </div>
    <div v-if="isIos" class="mt-3 p-2 mb-3">
      <div class="col-12">
        Your mixes, in your pocket.
        <a href="#" @click.prevent="iosInstall">Get the Mixbrite app</a>
      </div>
    </div>
  </div>
</template>

<script>
import { iosCopyToClipboard } from '../utils/ios_copy_to_clipboard'

export default {
  props: ['share'],
  methods: {
    iosInstall() {
      const el = document.getElementById('ios_copy_el')
      if (el) iosCopyToClipboard(el)
      document.cookie = "appInstalled=true"
      window.location = "https://apps.apple.com/us/app/mix-master-miles/id1516224866"
    }
  },
  computed: {
    acceptUrl() {
      return `/share/accept?token=${this.share.token}`
    },
    formattedDate() {
      return new Date(this.share.createdAt).toLocaleString()
    },
    isIos() {
      return /iPhone|iPad/i.test(navigator.userAgent)
    }
  }
}
</script>
